module.exports = __webpack_public_path__ + "img/33.20c23423.jpg";